import { Component, Inject } from '@angular/core'
import { HttpSessionsService } from '@helios/common-api'
import { BasePanelComponent, LayoutContainer } from '@helios/panel-base'
import { ComponentContainer } from 'golden-layout'
import { ResizeDirection, ResizeHandleState } from '@helios/generic-components'
import { PeriodLength, periodLengthToDate } from '@helios/state-management'
import { SessionsService } from '@helios/sessions'

export interface ExternalAccountsPanelState {
  resizeHandleState: ResizeHandleState
}

@Component({
  selector: 'hs-external-accounts-panel',
  templateUrl: './external-accounts-panel.component.html',
  styleUrls: ['./external-accounts-panel.component.scss'],
})
export class ExternalAccountsPanelComponent extends BasePanelComponent<ExternalAccountsPanelState> {
  readonly resizeDirection = ResizeDirection.Horizontal
  readonly actualReconDate = this.httpSessionsService.getReconDate()

  constructor(
    @Inject(LayoutContainer) container: ComponentContainer,
    private readonly httpSessionsService: HttpSessionsService,
    private readonly sessionsService: SessionsService,
  ) {
    super(container)
  }

  onResizeFinished(resizeHandleState: ResizeHandleState) {
    this.setState({
      ...this.state,
      resizeHandleState,
    })
  }

  /** @internal */
  async setLoadedAccount({
    accountIds,
    reconDate,
    withModal,
    isLIBAccount,
    periodLength,
  }: {
    accountIds: number[]
    reconDate: Date
    withModal: boolean
    isLIBAccount: boolean
    periodLength: PeriodLength
  }) {
    if (withModal) this.sessionsService.createFromModal(accountIds, reconDate)
    else {
      this.sessionsService.create(
        accountIds,
        reconDate,
        periodLengthToDate(periodLength),
        false,
        undefined,
        isLIBAccount,
      )
    }
  }
}
